import { BaseModal, ModalConstructor } from "./index";
import ViewRendeder from "../view/renderer";
import { BaseApp } from "../app";
import * as Dom from '../helpers/dom';
import { ViewEvent } from "../view/index";

export default class ModalManager
{
    private queue: BaseModal[];
    private app: BaseApp;
    private containerElement: HTMLElement;
    private waitingForNext: boolean;
    
    constructor(app: BaseApp)
    {
        this.app = app;
        this.queue = [];
        this.waitingForNext = false;
        this.containerElement = <HTMLElement>document.querySelector('[data-modal-container]');
    }

    private modalUnloaded = () =>
    {
        Dom.emptyElement(this.containerElement);
        this.next();
    };

    private next()
    {
        if (this.queue.length > 0)
        {
            this.containerElement.classList.add('active');
            let modal = this.queue.splice(0, 1)[0];
            modal.on(ViewEvent.UNLOAD, this.modalUnloaded);
            this.containerElement.appendChild(modal.element);
        }
        else
        {
            this.waitingForNext = false;
            this.containerElement.classList.remove('active');
        }
    }

    public show(modal: BaseModal): PromiseLike<void>
    {   
        return new Promise((resolve, reject) =>
        {
            modal.on(ViewEvent.UNLOAD, () => resolve());
            
            this.app.renderPartialView(modal).then(() => 
            {
                this.queue.push(modal);
    
                if (!this.waitingForNext)
                {
                    this.waitingForNext = true;
                    this.next();
                }
            });
        })
    }
}